import { Component, EventEmitter, Output, ViewChild } from '@angular/core';

import { ModalDirective } from 'ngx-bootstrap';

import { CBMError } from 'app/models';
import { FcdMapVersionStatusType } from 'app/models/enums';

@Component({
  selector: 'app-dialog-import-fcd',
  templateUrl: './dialog-import-fcd.component.html',
  styleUrls: ['./dialog-import-fcd.component.scss']
})
export class DialogImportFcdComponent {
  @ViewChild('importFcdDialog') importFcdDialog: ModalDirective;

  @Output() onConfirm = new EventEmitter<boolean>();
  @Output() onCancel = new EventEmitter<boolean>();

  public isFcdMapVersionStatusTypeOlder: boolean;
  public isFcdMapVersionStatusTypeEqual: boolean;

  errorMessages: CBMError[] = [];

  public singleColumnStyle: any = { label: 'col-xs-4', control: 'col-xs-8' };

  public show(mapVersionStatusType: FcdMapVersionStatusType): void {
    this.isFcdMapVersionStatusTypeOlder = mapVersionStatusType === FcdMapVersionStatusType.OLDER;
    this.isFcdMapVersionStatusTypeEqual = mapVersionStatusType === FcdMapVersionStatusType.EQUAL;
    this.importFcdDialog.show();
  }

  public hide(): void {
    this.importFcdDialog.hide();
  }

  public confirm(): void {
    this.importFcdDialog.hide();
    this.onConfirm.emit(true);
  }

  public cancel(): void {
    this.errorMessages = [];
    this.importFcdDialog.hide();
    this.onCancel.emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-import-fcd/dialog-import-fcd.component.ts